import { RcoSplitStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import ScalesIcon from "@redotech/redo-icons/scales-01.svg";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { isDef } from "@redotech/util/checks";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import { CollapseToggle, CollapsibleNodeData } from "./collapse-toggle";
import * as css from "./node.module.css";

export interface RcoSplitNodeData extends CollapsibleNodeData {
  step: PartialWithRequiredType<RcoSplitStep>;
  deleteElements: (id: string) => void;
  readonly: boolean;
}

export const RcoSplitNode = memo(function RcoSplitNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: RcoSplitNodeData;
  selected?: boolean | undefined;
}) {
  const { t } = useTranslation();

  return isDef(data.step.name) ? (
    <BaseNode
      containerClassName={css.checkoutNode}
      icon={<RedoFeaturedIcon color="warning" Icon={ScalesIcon} size="sm" />}
      onDelete={
        data.readonly || data.step.isActive
          ? undefined
          : () => data.deleteElements(id)
      }
      selected={selected}
      step={data.step}
      title={t("A/B test")}
    >
      <Handle id="top" position={Position.Top} type="target" />
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xxs" textColor="secondary">
          {t("Name")}
        </Text>
        <Flex w="full">
          <RedoBadge color="gray" size="xs" text={data.step.name} />
        </Flex>
      </Flex>
      <CollapseToggle
        descendantCount={data.descendantCount}
        isCollapsed={data.isCollapsed}
        toggleCollapse={data.toggleCollapse}
      />
      {!data.isCollapsed && (
        <Handle id="bottom" position={Position.Bottom} type="source" />
      )}
    </BaseNode>
  ) : null;
});
